import React from "react";
function ChangeOwner(props: any) {
	const { handleModal } = props;
	return (
		<div>
			<div
				className=" d-block justify-content-center cursor-pointer icon-content-holder"
				onClick={handleModal}
			>
				<img
					src="/images/reference.svg"
					style={{
						height: "24px",
						width: "24px",
						margin: "0px auto",
					}}
				/>
				<p style={{ fontSize: "10px" }}>CHANGE OWNER</p>
			</div>
		</div>
	);
}

export default ChangeOwner;
